/**
 * @fileoverview Civil liability, IMMEX permit, and implemented-practices selects.
 */

import Select from "react-select";
import { getSelectedOption, selectStyles } from "../../../utils/common";
import styles from "./Certifications.module.css";

/** Translation key for the "not visible field" message */
const NOT_VISIBLE_FIELD_MESSAGE_KEY =
  "components.corporateIdentity.notVisibleFieldMessage";

const InsuranceAndPracticesFields = ({ section, isTablet }) => {
  const {
    t,
    handleInputChange,
    seguroDeResponsabilidadCivil,
    setSeguroDeResponsabilidadCivil,
    civilLiabilityInsuranceOptions,
    permisoIMMEX,
    setPermisoIMMEX,
    IMMEXPermitOptions,
    practicasImplementadas,
    setPracticasImplementadas,
    practicesImplementedOptions,
  } = section;

  return (
    <div className={`${styles.inputRow} ${styles.twoInputsRow}`}>
      <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
        <label className={styles.inputLabel}>
          {t("components.certifications.civilLiabilityInsuranceLabel")}
        </label>
        <Select
          value={getSelectedOption(
            civilLiabilityInsuranceOptions,
            seguroDeResponsabilidadCivil,
          )}
          options={civilLiabilityInsuranceOptions}
          placeholder={t(
            "components.certifications.civilLiabilityInsurancePlaceholder",
          )}
          styles={selectStyles}
          className="select__control"
          onChange={(selectedOption) => {
            setSeguroDeResponsabilidadCivil(selectedOption.value);
            handleInputChange(
              "seguroDeResponsabilidadCivil",
              selectedOption.value,
            );
          }}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
      <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
        <label className={styles.inputLabel}>
          {t("components.certifications.IMMEXPermitLabel")}
        </label>
        <Select
          value={getSelectedOption(IMMEXPermitOptions, permisoIMMEX)}
          options={IMMEXPermitOptions}
          placeholder={t("components.certifications.IMMEXPermitPlaceholder")}
          styles={selectStyles}
          className="select__control"
          onChange={(selectedOption) => {
            setPermisoIMMEX(selectedOption.value);
            handleInputChange("permisoIMMEX", selectedOption.value);
          }}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
      <div
        className={`${styles.inputGroup} ${styles.twoLabelsGroup} ${
          isTablet ? styles.tabletGroup : ""
        }`}
      >
        <label className={`${styles.inputLabel} ${styles.noWrapLabel}`}>
          {t("components.certifications.practicesImplementedLabel")}
        </label>
        <Select
          value={getSelectedOption(
            practicesImplementedOptions,
            practicasImplementadas,
          )}
          options={practicesImplementedOptions}
          placeholder={t(
            "components.certifications.practicesImplementedPlaceholder",
          )}
          styles={selectStyles}
          className="select__control"
          onChange={(selectedOption) => {
            setPracticasImplementadas(selectedOption.value);
            handleInputChange("practicasImplementadas", selectedOption.value);
          }}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
    </div>
  );
};

export default InsuranceAndPracticesFields;
